<template>
  <div id="mngmnt-page">
    <div class="row no-margin-bottom switch-page-spacing" style="margin-top: 5px">
      <div class="col">
        <div class="breadcrumb-div">
          <span class="breadcrumb-link" ref="region-link" @click="navigateToList" >{{ $t('management.organisations') }}</span>
        </div>
        <div v-if="selectedOrganisation !== null" class="breadcrumb-div breadcrumb-link">&nbsp;/&nbsp;</div>
        <div v-if="selectedOrganisation !== null" class="breadcrumb-div" @mouseenter="toggleDepartments(true)" @mouseleave="toggleDepartments(false)">
          <span class="breadcrumb-link" ref="dept-link">{{ selectedOrganisation.OrganisationName }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div v-if="selectedOrganisation !== null" class="col s12">
        <div class="white">
          <div class="row tab-bar">
            <div v-for="item in navbar" :key="item.label" class="col s2 valign-wrapper"
                 :class="{ selected: item.component === selectedComponent }"
                 @click="navigateTab(item.component)">
              <i class="material-icons">{{ item.icon }}</i>{{ item.label }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col s10">
            <div class="z-depth-1 white">
              <div v-if="authorized" class="content">
                <Component v-bind:is="selectedComponent" :model="selectedOrganisation" :cancel-fn="navigateToList" />
              </div>
              <div v-else>
                <Home :message="$t('management.norights')" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="col s12">
        <div class="row">
          <div class="col s12">
            <div class="z-depth-1 white">
              <div class="content">
                <OrganisationList />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthenticationService from '../../services/AuthenticationService'
import Router from '../../router'
import OrganisationList from '../../components/usermanagement/organisations/OrganisationList'
import OrganisationEdit from '../../components/usermanagement/organisations/OrganisationEdit'
import organisationsApi from '../../services/api/OrganisationsApi'

export default {
  name: 'OrganisationManagement',
  components: {
    OrganisationList,
    OrganisationEdit
  },
  props: {},
  data () {
    return {
      authorized: false,
      selectedOrganisation: null,
      selectedComponent: 'OrganisationEdit',
      navbar: [
        {
          component: 'OrganisationEdit',
          icon: 'business',
          label: this.$t('management.editOrganisation')
        }
      ]
    }
  },
  computed: {
  },
  watch: {
    $route (to, from) {
      if (Router.currentRoute.params['id']) {
        const id = Router.currentRoute.params['id']
        organisationsApi.getOrganisation(id)
          .then(result => {
            const org = result.data
            this.selectedOrganisation = org
          })
      } else {
        this.selectedOrganisation = null
      }
    },
    breadCrumbRailObjectId (val) {
      this.changeRailObject(val)
    }
  },
  mounted () {
    const user = AuthenticationService.getUser()
    this.authorized = user.SystemRoleId >= 2
  },
  methods: {
    navigateToList () {
      Router.push('/organisations')
    },
    navigateTab (component) {
      this.selectedComponent = component
    }
  }
}
</script>

<style scoped>
  .tab-bar > div {
    height: 40px;
    padding-left: 25px;
    cursor: pointer;
  }
  .tab-bar > .selected {
    background-color: #2196F3;
    color: white;
  }
  #mngmnt-page {
    width: 100%;
    height: calc(100vh - 56px);
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .selected {
    background-color: #2196F3;
    color: white;
  }

  .content {
    margin: 0.5rem 0 0.5rem 0;
  }

  .breadcrumb-div {
    display: inline-block;
  }
  .breadcrumb-link {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0,0,0, .56);
    cursor: pointer;
  }
  .breadcrumb-link-main {
    font-family: Roboto;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    line-height: 32px;
    color: rgba(0, 0, 0, 0.87);
    /* cursor: pointer; */
  }
  .inner-breadcrumb-content {
    max-height: 300px;
    width: 345px;
    overflow-y: auto;
    background-color: white;
    /* border: 1px solid  rgba(0, 0, 0, 0.56); */
    font-family: Roboto;
  }
  .breadcrumb-table {
    position: relative;
  }
  .breadcrumb-table thead tr {
    border-top: 1px solid rgba(0, 0, 0, 0.4);
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  }
  .breadcrumb-table th, .breadcrumb-table td {
    padding: 5px 5px;
  }
  .inner-content {
    position: fixed;
    z-index: 4;
  }
  .slide-fade-enter-active {
    transition: all .4s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s ease;
  }
  .slide-fade-enter {
    transform: translateY(-50px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/management/OrganisationManagement.vue